export default __webpack_public_path__ + "static/media/Gilroy-Regular.86bc2a5a.otf";